import styled, { css } from "styled-components/macro";

export const AboutTheRoomWrapper = styled.div<{ error?: boolean }>`
  display: grid;
  gap: 16px;

  & b:not(:first-of-type) {
    display: none !important;
  }

  grid-template-areas:
    "titleAboutRoom titleAboutRoom"
    "bedroomSize houseSize"
    "sharedUse privateUse"
    "descriptionAboutRoom descriptionAboutRoom"
    "picturesRoom picturesRoom";
  grid-template-columns: repeat(2, 1fr);
  & section {
    width: 90%;
    max-width: 1080px;
    & .image-view {
      width: 100%;
    }
  }
  & #sharedUse {
    ${(props) =>
      props.error &&
      css`
        border: 1px solid red;
        border-radius: 4px;
      `}
  }
  @media ${(props) => props.theme.media.tablet} {
    grid-template-areas:
      "titleAboutRoom titleAboutRoom"
      "bedroomSize houseSize"
      "sharedUse privateUse"
      "descriptionAboutRoom descriptionAboutRoom"
      "picturesRoom picturesRoom";
  }
  @media ${(props) => props.theme.media.phone} {
    grid-template-areas:
      "titleAboutRoom"
      "bedroomSize"
      "houseSize"
      "sharedUse"
      "privateUse"
      "descriptionAboutRoom"
      "picturesRoom";
    grid-template-columns: 1fr;
    & section {
      padding: 0;
    }
  }

  #bedroomSize {
    grid-area: bedroomSize;
  }

  #houseSize {
    grid-area: houseSize;
  }

  #sharedUse {
    grid-area: sharedUse;
  }

  #privateUse {
    grid-area: privateUse;
  }

  #descriptionAboutRoom {
    grid-area: descriptionAboutRoom;
  }

  #picturesRoom {
    grid-area: picturesRoom;

    & .ant-upload-select,
    & .ant-image,
    & .ant-upload-list-picture-card-container {
      min-width: 30%;
      /* height: 200px; */
      margin: 0 12px 12px 0;
      text-justify: auto;
      & img {
        object-fit: cover;
      }
    }
    @media ${(props) => props.theme.media.phone} {
      & .ant-upload-select,
      & .ant-image,
      & .ant-upload-list-picture-card-container {
        min-width: 22%;
      }
    }
  }
  & li {
    list-style: none;
    margin-top: 8px;
  }
`;
